module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedContainer bottom"
  }, [_c('iframe', {
    attrs: {
      "allowfullscreen": "",
      "frameborder": "0",
      "src": _vm.src
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c6d7af","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IframeVideoPlayer/IframeVideoPlayer.vue
// module id = 3646
// module chunks = 1